/**
 * Tutoring Agreement Workflow Machine Config
 *
 * Domain: Tutoring > Agreement
 * Description: State machine for tutoring agreement lifecycle.
 * States: draft → active → expired/terminated
 */
export const tutoringAgreementConfig = {
    id: 'tutoring-agreement',
    initial: 'draft',
    states: {
        draft: {
            on: { ACTIVATE: { target: 'active', guard: 'hasValidDates' } },
        },
        active: {
            on: {
                EXPIRE: 'expired',
                TERMINATE: { target: 'terminated', guard: 'hasTerminationReason' },
            },
        },
        expired: {
            type: 'final',
        },
        terminated: {
            type: 'final',
        },
    },
};
//# sourceMappingURL=tutoring-agreement.js.map